import { paths } from 'src/routes/paths';

export const CONTACT_SECTION_ID = 'contact-us';

export const CONTACT_SECTION_HASH = `#${CONTACT_SECTION_ID}`;

/**
 * Extracts marketing page slug from a pathname like `/marketing/my-slug`.
 */
export function getMarketingSlug(pathname = '') {
  const match = pathname.match(/^\/marketing\/([^/]+)\/?$/);
  return match?.[1] ?? null;
}

/**
 * Resolves Contact Us navigation:
 * - Marketing page with contact section enabled → in-page section hash
 * - Otherwise → dedicated Contact Us screen
 */
export function resolveContactUsHref({ pathname, isContactEnabled = false } = {}) {
  // const slug = getMarketingSlug(pathname);
  const slug ='main-page';

  if (slug && isContactEnabled) {
    return CONTACT_SECTION_HASH;
  }

  return paths.contact;
}
